module.exports = __webpack_public_path__ + "static/media/how_sv.852ed7ce.vtt";